// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Panama from '../_raw/flag/icon_flag_panama.png';

export default () => <img src={Panama} alt="Panama" />;
